/** @format */

import { ENVIROMENT } from "../../../../../v2-config/constants/enviroment.constant"

export const linkToDetailProduct = (item) => {
		return `/products/${item.slug.trim()}-farmacias-${ENVIROMENT.ROOT_PHARMACY}`
}
